"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._WriteDropdownFieldInModule = exports._UpdateRenderOfRadioField = exports.WriteRadioFieldInModule = exports._WriteCheckboxField = exports._ClearFields = exports._ReadRadioField = exports._WriteField = exports._GetFieldDomObjInModule = exports._ReadFieldInModule = exports._PrefillFieldsInModule = exports._ReadFieldValueInModule = exports._ReadAllFieldsInModule = exports._CreateFormFieldsInModule = exports._ValidateAnyFieldInModule = exports.ValidateFieldsInModule = exports._GenerateFieldInModule = void 0;
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var translation_1 = __importDefault(require("../services/translation"));
var jquery_helper_const_1 = require("./dom-crud/jquery-helper.const");
var error_helper_const_1 = require("./error-handling/error-helper.const");
var helper_const_1 = require("./helper.const");
var input_output_helper_const_1 = require("./input-output-helper.const");
var input_mapping_const_1 = require("./input.mapping.const");
var validate_iban_1 = require("./forms/validate-iban");
var _GenerateFieldInModule = function (module, field) {
    return (0, input_output_helper_const_1._GenerateField)(module.$container, field);
};
exports._GenerateFieldInModule = _GenerateFieldInModule;
/**
 * Finds all input fields on the page / container and checks there state
 * @param module
 * @param $ignoreHiddenFields:
 * @returns
 */
var ValidateFieldsInModule = function (module, options, saveInLocalStorage) {
    var _a, _b, _c;
    if (options === void 0) { options = {
        showErrors: true,
        showSuccess: false,
        animateToFirstError: true,
        mappings: input_mapping_const_1._AllMappings,
    }; }
    if (saveInLocalStorage === void 0) { saveInLocalStorage = false; }
    options.showErrors = (_a = options.showErrors) !== null && _a !== void 0 ? _a : true;
    options.showSuccess = (_b = options.showSuccess) !== null && _b !== void 0 ? _b : false;
    options.animateToFirstError = (_c = options.animateToFirstError) !== null && _c !== void 0 ? _c : true;
    var mappingResult = {};
    var valid = true;
    var invalidFields = [];
    for (var key in options.mappings) {
        var field = options.mappings[key];
        if ((0, exports._GetFieldDomObjInModule)(field, module).length === 0) {
            if (options === null || options === void 0 ? void 0 : options.generateFieldsIfNotExists) {
                (0, exports._GenerateFieldInModule)(module, field);
            }
            else if (field === null || field === void 0 ? void 0 : field.ignoreValidationIfNotExisting) {
                //NOTE: if ignore optionals set we assume you dont want to validate optional fields that are not even represented as DOM object
                continue;
            }
        }
        var result = (0, exports._ValidateAnyFieldInModule)(module, field, options);
        // save result in local storage, even if its invalid
        if (saveInLocalStorage) {
            var fieldValue = (0, exports._ReadFieldValueInModule)(field, module);
            if (fieldValue && (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.length)) {
                localStorage.setItem(field.uid, fieldValue);
            }
        }
        if (result.valid === false) {
            valid = false;
            invalidFields.push(__assign(__assign({}, field), { error: result.error }));
            continue;
        }
        else {
            mappingResult = lodash_1.default.merge(mappingResult, result.data);
        }
    }
    if (!valid && options.animateToFirstError === true) {
        (0, error_helper_const_1._ScrollToFirstErrorField)(module.$container);
    }
    return { valid: valid, data: mappingResult, invalidFields: invalidFields };
};
exports.ValidateFieldsInModule = ValidateFieldsInModule;
/**
 * Validates a field with their settings
 * @param module
 * @param field
 * @param options
 * @returns
 */
var _ValidateAnyFieldInModule = function (module, field, options) {
    var _a, _b;
    if (options === void 0) { options = {
        showErrors: true,
        showSuccess: false,
    }; }
    options.showErrors = (_a = options.showErrors) !== null && _a !== void 0 ? _a : true;
    options.showSuccess = (_b = options.showSuccess) !== null && _b !== void 0 ? _b : false;
    var domObject = (0, exports._GetFieldDomObjInModule)(field, module);
    var mappingResult = {};
    var valid = true;
    (0, error_helper_const_1._RemoveStatusFromDomObject)(domObject);
    var errorMessage = '';
    var value = (0, exports._ReadFieldValueInModule)(field, module);
    var visible = (0, jquery_helper_const_1._IsVisible)(domObject);
    //IF its required and we have no value in input field, localstorage, or default - the field is invalid
    if ((field === null || field === void 0 ? void 0 : field.required) && !(value === null || value === void 0 ? void 0 : value.length) && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        valid = false;
        if (options === null || options === void 0 ? void 0 : options.showErrors) {
            (0, error_helper_const_1._AddErrorToDomObject)(domObject, translation_1.default.t('This is required'));
        }
        console.log('Field', field.uid, 'is required but missing, it has value', value, 'and is visible');
        return {
            valid: valid,
            data: mappingResult,
            error: translation_1.default.t('This is required'),
            visible: domObject.length > 0 ? true : false,
        };
    }
    if (field === null || field === void 0 ? void 0 : field.disabled) {
        domObject.attr('disabled', 'true');
    }
    if ((field === null || field === void 0 ? void 0 : field.regex) && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        var testResult = new RegExp(field.regex, 'g').test(value);
        if (options.showSuccess && testResult) {
            valid = true;
            (0, error_helper_const_1._AddSuccessToDomObject)(domObject, (field === null || field === void 0 ? void 0 : field.hideSuccessMessage) ? '' : undefined);
        }
        if (testResult === false) {
            valid = false;
            console.log('Field', field, 'is invalid with value', value, 'against regex', field.regex);
            errorMessage = field.regexError;
            if (options.showErrors) {
                (0, error_helper_const_1._AddErrorToDomObject)(domObject, field.regexError);
            }
        }
    }
    // iban validation?
    if (field.type === 'iban' && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        var ibanValRes = (0, validate_iban_1.validateIbanValue)(value);
        console.log('iban val res', ibanValRes);
        if (ibanValRes.state !== 'valid') {
            (0, error_helper_const_1._AddErrorToDomObject)(domObject, field.regexError);
            valid = false;
        }
    }
    lodash_1.default.set(mappingResult, field.uid, value);
    return {
        valid: valid,
        data: mappingResult,
        error: errorMessage,
        visible: domObject.length > 0 ? true : false,
    };
};
exports._ValidateAnyFieldInModule = _ValidateAnyFieldInModule;
/**
 * Creates input fields that are missing for module inside data-get="auto-form-fields" container
 * NOT USED ?
 * @param $container
 * @param refObjectAttr
 * @param attr
 */
var _CreateFormFieldsInModule = function (module, options) {
    var _a, _b;
    if (options === void 0) { options = {
        refObjectAttr: 'auto-form-fields',
        mappings: input_mapping_const_1._AllMappings,
    }; }
    var refObject = (0, helper_const_1._GetElementInModule)(module.$container, "[data-get=\"".concat(options.refObjectAttr, "\"]"));
    if (!refObject.length) {
        refObject = (0, cash_dom_1.default)('<div data-get="auto-form-fields"></div>');
        module.$container.append(refObject);
    }
    else {
        console.error('CREATE FORM FIELDS CALLED WITHOUT [data-get="' + options.refObjectAttr + '"]');
    }
    for (var key in options.mappings) {
        var field = options.mappings[key];
        if ((_a = (0, helper_const_1._GetElementInModule)(module.$container, "[data-get=\"".concat(field.uid, "\"]"))) === null || _a === void 0 ? void 0 : _a.length) {
            //already exists
        }
        else {
            refObject.append((0, cash_dom_1.default)('<input>').attr({
                id: (_b = field === null || field === void 0 ? void 0 : field.legacy) === null || _b === void 0 ? void 0 : _b.id,
                placeholder: field.uid,
                'data-get': field.uid,
            }));
        }
    }
};
exports._CreateFormFieldsInModule = _CreateFormFieldsInModule;
/**
 * Tries to gather all data that is either in input fields or localstorage
 */
var _ReadAllFieldsInModule = function (mappings, module) {
    if (mappings === void 0) { mappings = input_mapping_const_1._AllMappings; }
    var data = {};
    for (var key in mappings) {
        var field = mappings[key];
        var value = (0, exports._ReadFieldValueInModule)(field, module);
        if (value) {
            lodash_1.default.set(data, field.uid, value);
        }
    }
    return data;
};
exports._ReadAllFieldsInModule = _ReadAllFieldsInModule;
/**
 * Gets value from input field, localstorage or defaultValue in this order
 */
var _ReadFieldValueInModule = function (field, module) {
    var _a;
    var domObject = (0, exports._GetFieldDomObjInModule)(field, module);
    //by default we search input field, localstorage and default values
    var value = (_a = [(0, exports._ReadFieldInModule)(field, module), (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(field), field === null || field === void 0 ? void 0 : field.defaultValue].find(function (a) { return a === null || a === void 0 ? void 0 : a.length; })) !== null && _a !== void 0 ? _a : '';
    // The assumption is that if you have a input field on the page you want to overwrite even with empty values
    // Ignore hidden text fields
    if (domObject.length && (0, jquery_helper_const_1._IsVisible)(domObject)) {
        value = (0, exports._ReadFieldInModule)(field, module);
    }
    return value;
};
exports._ReadFieldValueInModule = _ReadFieldValueInModule;
/**
 * Prefill all fields with values from either localstorage or fields themselve
 * NOT USED ?
 * @param module
 */
var _PrefillFieldsInModule = function (module, options) {
    if (options === void 0) { options = { mappings: input_mapping_const_1._AllMappings }; }
    if (!options.values && !(0, input_output_helper_const_1._ShouldPrefillFromLocalStorage)())
        return;
    for (var key in options.mappings) {
        var field = options.mappings[key];
        var value = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(field);
        if (options === null || options === void 0 ? void 0 : options.values) {
            value = lodash_1.default.get(options.values, field.uid);
        }
        (0, exports._WriteField)(field, value, module);
    }
};
exports._PrefillFieldsInModule = _PrefillFieldsInModule;
/**
 * Returns value of legacy input field or modern ui field
 * @param field
 * @param $container
 * @returns
 */
var _ReadFieldInModule = function (field, module, dataType) {
    if (dataType === void 0) { dataType = 'get'; }
    var value = undefined;
    // gender can be on a div (normal case for a radio input, or on a select, then use the dropdown value)
    if (field.uid === 'customer.gender') {
        var elem = module.$container.find("[data-get='".concat(field.uid, "']"));
        if (elem.is('select')) {
            return elem.val();
        }
    }
    if (field.type === 'checkbox') {
        value = (0, exports._ReadRadioField)(field, module, dataType);
    }
    else if (field.type === 'radio') {
        value = (0, exports._ReadRadioField)(field, module, dataType);
    }
    else {
        value = (0, exports._GetFieldDomObjInModule)(field, module, dataType).val();
    }
    return value;
};
exports._ReadFieldInModule = _ReadFieldInModule;
/**
 * Returns either some legacy input field or modern uid field
 * @param field
 * @param module
 * @returns
 */
var _GetFieldDomObjInModule = function (field, module, dataType) {
    var _a, _b;
    if (dataType === void 0) { dataType = 'get'; }
    var fieldLegacy = (0, helper_const_1._GetElementInModule)(module.$container, (_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id);
    var fieldLegacy2 = (0, helper_const_1._GetElementInModule)(module.$container, (_b = field === null || field === void 0 ? void 0 : field.legacy) === null || _b === void 0 ? void 0 : _b.id2); //what if legacy id2 is undefined??
    var fieldUid = (0, helper_const_1._GetElementInModule)(module.$container, "[data-".concat(dataType, "=\"").concat(field.uid, "\"]"));
    var domObject = [fieldUid, fieldLegacy2, fieldLegacy].find(function (a) { return a.length; });
    return domObject !== null && domObject !== void 0 ? domObject : (0, cash_dom_1.default)();
};
exports._GetFieldDomObjInModule = _GetFieldDomObjInModule;
/**
 * Write a value to either dropdown, input or checkbox fields. Automatically detects what to fill where
 * @param field
 * @param value
 * @param $container
 */
var _WriteField = function (field, value, module) {
    var returnObject = {};
    if (field.type === 'text') {
        (0, exports._GetFieldDomObjInModule)(field, module).val(value);
    }
    else if (field.type === 'dropdown') {
        (0, exports._WriteDropdownFieldInModule)(field, value, module);
    }
    else if (field.type === 'radio') {
        (0, exports.WriteRadioFieldInModule)(field, value, module);
    }
    else if (field.type === 'checkbox') {
        // some parts write undefined or "" or null, which causes the checkbox to be still checked
        // but the function only checks the visible checkbox, not the hidden one, causing errors with webflow validation
        //_WriteCheckboxField(field, value, $container);
    }
    lodash_1.default.set(returnObject, field.uid, value);
    return returnObject;
};
exports._WriteField = _WriteField;
var _ReadRadioField = function (field, module, dataType) {
    var _a;
    if (dataType === void 0) { dataType = 'get'; }
    //if data-get is the wrapper
    var cont = (0, helper_const_1._GetElementInModule)(module.$container, "[data-".concat(dataType, "=\"").concat(field.uid, "\"]"));
    var value = (cont.find('input:checked').val() || cont.filter('input:checked').val());
    if (!(value === null || value === void 0 ? void 0 : value.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        var legacyElem = (0, helper_const_1._GetElementInModule)(module.$container, field.legacy.id);
        if (legacyElem.length > 0) {
            var isChecked = (0, helper_const_1._GetElementInModule)(module.$container, field.legacy.id).is(':checked');
            value = isChecked ? (0, helper_const_1._GetElementInModule)(module.$container, field.legacy.id).val() : '';
        }
        // old version, .val() always returns a valid string
        //value = $container.find(field.legacy.id).val() as string;
    }
    return value;
};
exports._ReadRadioField = _ReadRadioField;
var _ClearFields = function (module, fields) {
    if (fields === void 0) { fields = input_mapping_const_1._AllMappings; }
    console.info('Clear fields', fields);
    for (var key in fields) {
        var field = fields[key];
        (0, exports._WriteField)(field, '', module);
    }
};
exports._ClearFields = _ClearFields;
var _WriteCheckboxField = function (field, value, module) {
    var _a;
    //CURRENTLY NOT LEGACY SUPPORTED
    var cont = (0, helper_const_1._GetElementInModule)(module.$container, "[data-get=\"".concat(field.uid, "\"]"));
    var checkbox = cont.find('input');
    if (!(checkbox === null || checkbox === void 0 ? void 0 : checkbox.length)) {
        checkbox = cont.filter('input');
    }
    if (!(checkbox === null || checkbox === void 0 ? void 0 : checkbox.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        checkbox = (0, helper_const_1._GetElementInModule)(module.$container, field.legacy.id);
    }
    if (checkbox.length) {
        checkbox.prop('checked', false);
        checkbox.prop('checked', value === null || value === void 0 ? void 0 : value.length);
        if (value === null || value === void 0 ? void 0 : value.length) {
            checkbox.get(0).click();
            checkbox.siblings('.w-checkbox-input').addClass('w--redirected-checked');
        }
        else {
            checkbox.siblings('.w-checkbox-input').removeClass('w--redirected-checked');
        }
    }
};
exports._WriteCheckboxField = _WriteCheckboxField;
var WriteRadioFieldInModule = function (field, value, module) {
    var _a;
    //CURRENTLY NOT LEGACY SUPPORTED
    var cont = (0, helper_const_1._GetElementInModule)(module.$container, "[data-get=\"".concat(field.uid, "\"]"));
    var radioButtons = cont.find('input[type=radio][value="' + value + '"]');
    if (!(radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.length)) {
        radioButtons = cont.filter('input[type=radio][value="' + value + '"]');
    }
    if (!(radioButtons === null || radioButtons === void 0 ? void 0 : radioButtons.length) && ((_a = field === null || field === void 0 ? void 0 : field.legacy) === null || _a === void 0 ? void 0 : _a.id)) {
        radioButtons = (0, helper_const_1._GetElementInModule)(module.$container, field.legacy.id);
    }
    if (radioButtons.length) {
        (0, exports._UpdateRenderOfRadioField)(radioButtons, !!(value === null || value === void 0 ? void 0 : value.length));
    }
};
exports.WriteRadioFieldInModule = WriteRadioFieldInModule;
var _UpdateRenderOfRadioField = function (radioButtons, value) {
    radioButtons.prop('checked', false);
    radioButtons.prop('checked', value);
    if (value) {
        radioButtons.get(0).click();
        radioButtons.siblings('.w-radio-input').addClass('w--redirected-checked');
    }
    else {
        radioButtons.siblings('.w-radio-input').removeClass('w--redirected-checked');
    }
};
exports._UpdateRenderOfRadioField = _UpdateRenderOfRadioField;
var _WriteDropdownFieldInModule = function (field, value, module) {
    (0, helper_const_1._GetElementInModule)(module.$container, "[data-get=\"".concat(field.uid, "\"] option[value=\"").concat(value, "\"]")).attr('selected', 'true');
    (0, helper_const_1._GetElementInModule)(module.$container, "".concat(field.legacy.id, " option[value=\"").concat(value, "\"]")).attr('selected', 'true');
    (0, helper_const_1._GetElementInModule)(module.$container, "".concat(field.legacy.id2, " option[value=\"").concat(value, "\"]")).attr('selected', 'true');
};
exports._WriteDropdownFieldInModule = _WriteDropdownFieldInModule;
